import { render, staticRenderFns } from "./BizFlow.vue?vue&type=template&id=348e781d&scoped=true"
import script from "./BizFlow.vue?vue&type=script&lang=js"
export * from "./BizFlow.vue?vue&type=script&lang=js"
import style0 from "./BizFlow.vue?vue&type=style&index=0&id=348e781d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e781d",
  null
  
)

export default component.exports